import type { FC } from 'react';

import { ButtonStyled } from './Button.styled.ts';
import type { ButtonProps } from './Button.types.ts';

const Button: FC<ButtonProps> = ({ variant = 'primary', ...props }) => {
  return (
    <ButtonStyled
      {...props}
      variant={variant}
      disabled={props.disabled || false}
    />
  );
};

export default Button;
